<div class="images-slider-section-container">
  <img *ngIf="!imagesCards[idx].video" [src]="imagesCards[idx].img" [ngClass]="animationClass" [style]="setPosition()" alt="imagesCard">
  <video *ngIf="imagesCards[idx].video" autoplay loop [muted]="true" playsinline>
    <source [src]="imagesCards[idx].video" type="video/mp4">
  </video>
  <div class="images-slider-section-content">
    <div class="images-slider-section-title" *ngIf="imagesCards[idx]">
      {{ imagesCards[idx].title }}
    </div>
    <div class="images-slider-section-subtitle" *ngIf="imagesCards[idx]" [style]="imagesCards[idx].profit ? 'flex-direction: column;' : ''">
      <div class="images-slider-section-subtitle-items">
        <p>{{ imagesCards[idx].firstText }}</p>
        <p *ngIf="imagesCards[idx].secondText.length > 0" class="p-margin">
          {{ imagesCards[idx].secondText }}
        </p>
        <p *ngIf="imagesCards[idx].thirdText" class="p-margin">
          {{ imagesCards[idx].thirdText }}
        </p>
      </div>
      <div *ngIf="imagesCards[idx].achievements" class="images-slider-section-achievements">
        <img src="app/assets/images/achievements.png" alt="achievements">
      </div>
      <div *ngIf="imagesCards[idx].profit" class="images-slider-section-profit">
        <img src="app/assets/images/profit.png" alt="profit">
      </div>
    </div>
        <div class="images-slider-section-arrows">
      <div class="images-slider-section-arrow" (click)="turnLeft()">
        <app-icon [icon]="iconLeft" (mouseover)="mouseOver(true)" (mouseleave)="mouseLeave()"></app-icon>
      </div>
      <div class="images-slider-section-arrow" (click)="turnRight()">
        <app-icon [icon]="iconRight" (mouseover)="mouseOver(false)" (mouseleave)="mouseLeave()"></app-icon>
      </div>
    </div>
  </div>
</div>
